export default __webpack_public_path__ + "static/media/3 of a Kind.4dad7416.mp3";